import {
  Avatar,
  AvatarFallback,
  BodyText,
  Tooltip,
  toast,
} from "@/components/ui";
import { getInitials } from "@/lib/utils";
import { useParams } from "@tanstack/react-router";
import { UserRoundX } from "lucide-react";
import { useRemoveCareMember } from "../../network/useRemoveCareMember";

// TODO: decide how to handle with with design/eng -> we need to persist old colors? do colors still matter in new design?
const colors: { [key: string]: string } = {
  PCP: "#4DB6AC",
  Collaborator: "#F8BBD0",
  "Covering Clinician": "#F8BBD0",
};

interface CollaboratorProps {
  practitionerId: string | undefined;
  display: string;
  type: string;
  removable: boolean;
}

export const Collaborator = ({
  practitionerId,
  display,
  type,
  removable,
}: CollaboratorProps) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const { mutateAsync } = useRemoveCareMember(patientId);

  const displayWithoutPrefix = display.replace(/^Dr\.?\s+/, "").trim();

  const handleClickRemove = async () => {
    if (!practitionerId) return;
    try {
      await mutateAsync({
        practitionerId: practitionerId,
      });
    } catch (error) {
      toast.error("Failed to remove practitioner");
    }
  };

  return (
    <Tooltip key={display} tooltipContentText={`${display} (${type})`}>
      <Avatar className="w-6 h-6">
        <AvatarFallback
          style={{
            backgroundColor: colors[type],
          }}
          className="relative group"
        >
          {removable && (
            <button
              data-testid="remove-collaborator"
              type="button"
              onClick={handleClickRemove}
              className="absolute h-full w-full flex justify-center items-center bg-secondary opacity-0 invisisble group-hover:opacity-100 group-hover:visible"
            >
              <UserRoundX size={14} className="text-primary" />
            </button>
          )}

          <BodyText size="xs">
            {getInitials(displayWithoutPrefix, { max: 2 })}
          </BodyText>
        </AvatarFallback>
      </Avatar>
    </Tooltip>
  );
};
